/**
 * CURRENT_MEMBER_GRADE 格式正则为:
 * CURRENT_MEMBER_GRADE(123)
 */

import Declaration, { DeclarationFactory } from './base';


// tslint:disable-next-line
class CURRENT_MEMBER_GRADEDeclaration extends Declaration implements DeclarationFactory {

  public declaration = 'CURRENT_MEMBER_GRADE';

  public generateRegExp() {
    return /(^CURRENT_MEMBER_GRADE\(\d+\))/i;
  }

  public match(input: string) {
    const matchedDate = input.match(/^(CURRENT_MEMBER_GRADE\(([^)]*)\))/i);

    if (matchedDate) {
      if (/^\d+$/.test(matchedDate[2])) {
        const value = Number(matchedDate[2]);
        return {
          type: 'Id',
          declaration: this.declaration,
          raw: matchedDate[1],
          value,
          isAtom: true,
          isDeclaration: true
        };
      } else {
        throw this.generateInvalidError(matchedDate[1], matchedDate[2], '无效的当前会员等级体系');
      }
    }
  }

}

export default new CURRENT_MEMBER_GRADEDeclaration();
